import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ResolveImage from 'components/ResolveImage';
import DataRoomEmptyImage from 'assets/images/data-room-empty-image.webp';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import { Link } from 'react-router-dom';
import { getBuyingPortfolio } from 'utils';
import ChatIcon from 'icons/Chat.icon';
import { NEW_WINDOW_PROPS } from 'data/global';

import './DataRoomDocEmpty.styles.scss';

type DataRoomDocEmptyProps = {
  className?: string;
};

const DataRoomDocEmpty: React.FC<DataRoomDocEmptyProps> = (props) => {
  const { className } = props;
  const { t } = useTranslation();
  const {
    isPublishingAllowed,
    isBuySide,
    dataRoom: {
      dealRoom: { listingEnquiryId },
      currentMember: { sessionId },
    },
  } = useContext(DataRoomContext);

  const classes = classNames('data-room-doc-empty', className);

  const canMessageSellSide = useMemo(
    () => isBuySide && sessionId,
    [isBuySide, sessionId],
  );

  return (
    <div className={classes}>
      <ResolveImage
        src={DataRoomEmptyImage}
        asIllustration
        alt="There are no files yet."
      />
      <p>{t(isPublishingAllowed ? 'startAddingDocsDR' : 'noFilesAvailable')}</p>

      {canMessageSellSide && (
        <Link
          to={`${getBuyingPortfolio(
            listingEnquiryId,
            'messaging',
          )}/${sessionId}`}
          {...NEW_WINDOW_PROPS}
          className="as-button ncoded-button ncoded-button--outline"
        >
          <ChatIcon />
          {t('messageSellSide')}
        </Link>
      )}
    </div>
  );
};

export default DataRoomDocEmpty;
